import { useEffect, useState } from "react";
import { AutocompleteInput } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomFilterSelect from "./CustomFilterSelect";

const FilterProduct = (props: any) => {
  const [productList, setProductList] = useState([]);
  useEffect(() => {
    const fetchProductList = async () => {
      const reqUrl = "products/shortList";
      await sendRequest(reqUrl, {
        id: 1,
        data: {
          status: 1, //only active products
        },
      }).then((response) => {
        if (response) {
          setProductList(response);
        }
      });
    };
    fetchProductList();
  }, []);

  const productData = productList.map((product: any) => {
    return { id: product.name, name: product.name };
    // return { id: product.name, name: "[" + product.id + "] " + product.name };
  });
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="product"
      label="Product"
      choices={productData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterProduct;
